module.exports = __webpack_public_path__ + "static/img/2.1aaeb2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/article/2.jpg
// module id = rPVP
// module chunks = 1